import type { CommandDef } from '../types';

export const COMMANDS: CommandDef[] = [
  { name: 'documentclass', template: 'documentclass[${1:options}]{${2:article}}', detail: 'core' },
  { name: 'usepackage', template: 'usepackage[${1:options}]{${2:package}}', detail: 'core' },
  { name: 'begin', template: 'begin{${1:env}}\n\t${2}\n\\end{${1}}', detail: 'core' },
  { name: 'end', template: 'end{${1:env}}', detail: 'core' },
  { name: 'title', template: 'title{${1:title}}', detail: 'core' },
  { name: 'author', template: 'author{${1:name}}', detail: 'core' },
  { name: 'date', template: 'date{${1:\\today}}', detail: 'core' },
  { name: 'maketitle', detail: 'core' },
  { name: 'today', detail: 'core' },
  { name: 'newpage', detail: 'core' },
  { name: 'clearpage', detail: 'core' },
  { name: 'pagebreak', detail: 'core' },
  { name: 'linebreak', detail: 'core' },
  { name: 'newline', detail: 'core' },
  { name: 'noindent', detail: 'core' },
  { name: 'indent', detail: 'core' },
  { name: 'item', template: 'item ${1}', detail: 'core' },
  { name: 'tableofcontents', detail: 'core' },
  { name: 'listoffigures', detail: 'core' },
  { name: 'listoftables', detail: 'core' },
  { name: 'appendix', detail: 'core' },
  { name: 'footnote', template: 'footnote{${1:text}}', detail: 'core' },
  { name: 'caption', template: 'caption{${1:caption}}', detail: 'core' },
  { name: 'centering', detail: 'core' },
  { name: 'small', detail: 'core' },
  { name: 'large', detail: 'core' },
  { name: 'Large', detail: 'core' },
  { name: 'LARGE', detail: 'core' },
  { name: 'huge', detail: 'core' },
  { name: 'tiny', detail: 'core' },
  { name: 'normalsize', detail: 'core' },

  { name: 'part', template: 'part{${1:title}}', detail: 'sectioning' },
  { name: 'chapter', template: 'chapter{${1:title}}', detail: 'sectioning' },
  { name: 'section', template: 'section{${1:title}}', detail: 'sectioning' },
  { name: 'subsection', template: 'subsection{${1:title}}', detail: 'sectioning' },
  { name: 'subsubsection', template: 'subsubsection{${1:title}}', detail: 'sectioning' },
  { name: 'paragraph', template: 'paragraph{${1:title}}', detail: 'sectioning' },
  { name: 'subparagraph', template: 'subparagraph{${1:title}}', detail: 'sectioning' },

  { name: 'textbf', template: 'textbf{${1:text}}', detail: 'text format' },
  { name: 'textit', template: 'textit{${1:text}}', detail: 'text format' },
  { name: 'emph', template: 'emph{${1:text}}', detail: 'text format' },
  { name: 'underline', template: 'underline{${1:text}}', detail: 'text format' },
  { name: 'textsc', template: 'textsc{${1:text}}', detail: 'text format' },
  { name: 'texttt', template: 'texttt{${1:text}}', detail: 'text format' },
  { name: 'textrm', template: 'textrm{${1:text}}', detail: 'text format' },
  { name: 'textsf', template: 'textsf{${1:text}}', detail: 'text format' },
  { name: 'textnormal', template: 'textnormal{${1:text}}', detail: 'text format' },
  { name: 'textsuperscript', template: 'textsuperscript{${1:text}}', detail: 'text format' },
  { name: 'textsubscript', template: 'textsubscript{${1:text}}', detail: 'text format' },

  { name: 'label', template: 'label{${1:key}}', detail: 'ref' },
  { name: 'ref', template: 'ref{${1:key}}', detail: 'ref' },
  { name: 'eqref', template: 'eqref{${1:key}}', detail: 'amsmath' },
  { name: 'pageref', template: 'pageref{${1:key}}', detail: 'ref' },
  { name: 'autoref', template: 'autoref{${1:key}}', detail: 'hyperref' },
  { name: 'nameref', template: 'nameref{${1:key}}', detail: 'hyperref' },
  { name: 'cref', template: 'cref{${1:key}}', detail: 'cleveref' },
  { name: 'Cref', template: 'Cref{${1:key}}', detail: 'cleveref' },

  { name: 'cite', template: 'cite{${1:key}}', detail: 'bib' },
  { name: 'citep', template: 'citep{${1:key}}', detail: 'natbib' },
  { name: 'citet', template: 'citet{${1:key}}', detail: 'natbib' },
  { name: 'citeauthor', template: 'citeauthor{${1:key}}', detail: 'bib' },
  { name: 'citeyear', template: 'citeyear{${1:key}}', detail: 'bib' },
  { name: 'nocite', template: 'nocite{${1:key}}', detail: 'bib' },
  { name: 'parencite', template: 'parencite{${1:key}}', detail: 'biblatex' },
  { name: 'textcite', template: 'textcite{${1:key}}', detail: 'biblatex' },
  { name: 'bibliography', template: 'bibliography{${1:refs}}', detail: 'bib' },
  { name: 'bibliographystyle', template: 'bibliographystyle{${1:plain}}', detail: 'bib' },
  { name: 'printbibliography', detail: 'biblatex' },

  { name: 'input', template: 'input{${1:file}}', detail: 'core' },
  { name: 'include', template: 'include{${1:file}}', detail: 'core' },
  { name: 'subfile', template: 'subfile{${1:file}}', detail: 'subfiles' },
  { name: 'includegraphics', template: 'includegraphics[width=${1:0.7\\linewidth}]{${2:file}}', detail: 'graphicx' },
  { name: 'graphicspath', template: 'graphicspath{{${1:./}}}', detail: 'graphicx' },

  { name: 'frac', template: 'frac{${1:num}}{${2:den}}', detail: 'math' },
  { name: 'dfrac', template: 'dfrac{${1:num}}{${2:den}}', detail: 'amsmath' },
  { name: 'tfrac', template: 'tfrac{${1:num}}{${2:den}}', detail: 'amsmath' },
  { name: 'sqrt', template: 'sqrt[${1}]{${2:expr}}', detail: 'math' },
  { name: 'sum', template: 'sum_{${1:i=0}}^{${2:n}} ${3}', detail: 'math' },
  { name: 'prod', template: 'prod_{${1:i=0}}^{${2:n}} ${3}', detail: 'math' },
  { name: 'int', template: 'int_{${1:0}}^{${2:1}} ${3} \\, d${4:x}', detail: 'math' },
  { name: 'lim', template: 'lim_{${1:x \\to \\infty}} ${2}', detail: 'math' },
  { name: 'binom', template: 'binom{${1:n}}{${2:k}}', detail: 'amsmath' },

  { name: 'sin', detail: 'math' },
  { name: 'cos', detail: 'math' },
  { name: 'tan', detail: 'math' },
  { name: 'log', detail: 'math' },
  { name: 'ln', detail: 'math' },
  { name: 'exp', detail: 'math' },
  { name: 'min', detail: 'math' },
  { name: 'max', detail: 'math' },
  { name: 'inf', detail: 'math' },
  { name: 'sup', detail: 'math' },

  { name: 'alpha', detail: 'greek' },
  { name: 'beta', detail: 'greek' },
  { name: 'gamma', detail: 'greek' },
  { name: 'delta', detail: 'greek' },
  { name: 'epsilon', detail: 'greek' },
  { name: 'varepsilon', detail: 'greek' },
  { name: 'zeta', detail: 'greek' },
  { name: 'eta', detail: 'greek' },
  { name: 'theta', detail: 'greek' },
  { name: 'iota', detail: 'greek' },
  { name: 'kappa', detail: 'greek' },
  { name: 'lambda', detail: 'greek' },
  { name: 'mu', detail: 'greek' },
  { name: 'nu', detail: 'greek' },
  { name: 'xi', detail: 'greek' },
  { name: 'pi', detail: 'greek' },
  { name: 'rho', detail: 'greek' },
  { name: 'sigma', detail: 'greek' },
  { name: 'tau', detail: 'greek' },
  { name: 'upsilon', detail: 'greek' },
  { name: 'phi', detail: 'greek' },
  { name: 'varphi', detail: 'greek' },
  { name: 'chi', detail: 'greek' },
  { name: 'psi', detail: 'greek' },
  { name: 'omega', detail: 'greek' },
  { name: 'Gamma', detail: 'greek' },
  { name: 'Delta', detail: 'greek' },
  { name: 'Theta', detail: 'greek' },
  { name: 'Lambda', detail: 'greek' },
  { name: 'Sigma', detail: 'greek' },
  { name: 'Phi', detail: 'greek' },
  { name: 'Psi', detail: 'greek' },
  { name: 'Omega', detail: 'greek' },

  { name: 'cdot', detail: 'math symbol' },
  { name: 'cdots', detail: 'math symbol' },
  { name: 'ldots', detail: 'math symbol' },
  { name: 'vdots', detail: 'math symbol' },
  { name: 'ddots', detail: 'math symbol' },
  { name: 'times', detail: 'math symbol' },
  { name: 'div', detail: 'math symbol' },
  { name: 'pm', detail: 'math symbol' },
  { name: 'mp', detail: 'math symbol' },
  { name: 'leq', detail: 'math symbol' },
  { name: 'geq', detail: 'math symbol' },
  { name: 'neq', detail: 'math symbol' },
  { name: 'approx', detail: 'math symbol' },
  { name: 'equiv', detail: 'math symbol' },
  { name: 'sim', detail: 'math symbol' },
  { name: 'simeq', detail: 'math symbol' },
  { name: 'in', detail: 'math symbol' },
  { name: 'notin', detail: 'math symbol' },
  { name: 'subset', detail: 'math symbol' },
  { name: 'subseteq', detail: 'math symbol' },
  { name: 'supset', detail: 'math symbol' },
  { name: 'supseteq', detail: 'math symbol' },
  { name: 'cup', detail: 'math symbol' },
  { name: 'cap', detail: 'math symbol' },
  { name: 'emptyset', detail: 'math symbol' },
  { name: 'varnothing', detail: 'amsmath' },
  { name: 'infty', detail: 'math symbol' },
  { name: 'partial', detail: 'math symbol' },
  { name: 'nabla', detail: 'math symbol' },
  { name: 'forall', detail: 'math symbol' },
  { name: 'exists', detail: 'math symbol' },
  { name: 'to', detail: 'math symbol' },
  { name: 'rightarrow', detail: 'math symbol' },
  { name: 'leftarrow', detail: 'math symbol' },
  { name: 'Rightarrow', detail: 'math symbol' },
  { name: 'Leftarrow', detail: 'math symbol' },
  { name: 'Leftrightarrow', detail: 'math symbol' },
  { name: 'mapsto', detail: 'math symbol' },
  { name: 'land', detail: 'math symbol' },
  { name: 'lor', detail: 'math symbol' },
  { name: 'lnot', detail: 'math symbol' },

  { name: 'mathbb', template: 'mathbb{${1:R}}', detail: 'amsmath' },
  { name: 'mathcal', template: 'mathcal{${1:A}}', detail: 'amsmath' },
  { name: 'mathfrak', template: 'mathfrak{${1:g}}', detail: 'amsmath' },
  { name: 'mathrm', template: 'mathrm{${1:text}}', detail: 'math' },
  { name: 'mathbf', template: 'mathbf{${1:v}}', detail: 'math' },
  { name: 'mathit', template: 'mathit{${1:x}}', detail: 'math' },
  { name: 'mathsf', template: 'mathsf{${1:x}}', detail: 'math' },
  { name: 'mathtt', template: 'mathtt{${1:x}}', detail: 'math' },
  { name: 'text', template: 'text{${1:text}}', detail: 'amsmath' },
  { name: 'operatorname', template: 'operatorname{${1:name}}', detail: 'amsmath' },
  { name: 'overline', template: 'overline{${1:x}}', detail: 'math' },
  { name: 'overrightarrow', template: 'overrightarrow{${1:v}}', detail: 'math' },
  { name: 'hat', template: 'hat{${1:x}}', detail: 'math' },
  { name: 'tilde', template: 'tilde{${1:x}}', detail: 'math' },
  { name: 'bar', template: 'bar{${1:x}}', detail: 'math' },
  { name: 'vec', template: 'vec{${1:v}}', detail: 'math' },
  { name: 'dot', template: 'dot{${1:x}}', detail: 'math' },
  { name: 'ddot', template: 'ddot{${1:x}}', detail: 'math' },

  { name: 'left', detail: 'math delim' },
  { name: 'right', detail: 'math delim' },
  { name: 'big', detail: 'math delim' },
  { name: 'Big', detail: 'math delim' },
  { name: 'bigg', detail: 'math delim' },
  { name: 'Bigg', detail: 'math delim' },

  { name: 'hline', detail: 'tabular' },
  { name: 'cline', template: 'cline{${1:1-2}}', detail: 'tabular' },
  { name: 'multicolumn', template: 'multicolumn{${1:2}}{${2:c}}{${3:text}}', detail: 'tabular' },
  { name: 'multirow', template: 'multirow{${1:2}}{${2:*}}{${3:text}}', detail: 'multirow' },
  { name: 'toprule', detail: 'booktabs' },
  { name: 'midrule', detail: 'booktabs' },
  { name: 'bottomrule', detail: 'booktabs' },

  { name: 'newcommand', template: 'newcommand{\\${1:name}}[${2:0}]{${3:def}}', detail: 'core' },
  { name: 'renewcommand', template: 'renewcommand{\\${1:name}}[${2:0}]{${3:def}}', detail: 'core' },
  { name: 'providecommand', template: 'providecommand{\\${1:name}}[${2:0}]{${3:def}}', detail: 'core' },
  { name: 'newenvironment', template: 'newenvironment{${1:name}}{${2:begin}}{${3:end}}', detail: 'core' },
  { name: 'def', template: 'def\\${1:name}{${2:def}}', detail: 'tex' },

  { name: 'url', template: 'url{${1:https://}}', detail: 'hyperref' },
  { name: 'href', template: 'href{${1:url}}{${2:text}}', detail: 'hyperref' },
  { name: 'hyperref', template: 'hyperref[${1:key}]{${2:text}}', detail: 'hyperref' },

  { name: 'quad', detail: 'spacing' },
  { name: 'qquad', detail: 'spacing' },
  { name: 'hspace', template: 'hspace{${1:1em}}', detail: 'spacing' },
  { name: 'vspace', template: 'vspace{${1:1em}}', detail: 'spacing' },
  { name: 'hfill', detail: 'spacing' },
  { name: 'vfill', detail: 'spacing' },
  { name: 'smallskip', detail: 'spacing' },
  { name: 'medskip', detail: 'spacing' },
  { name: 'bigskip', detail: 'spacing' },
];
